import { DataDisplayPropertyModel } from '../../Models/DataDisplayPropertyModel';
import InputContentChip from './InputContentChip';

type DataDisplayPropertiesInputContentProps = {
	value: DataDisplayPropertyModel[] | undefined;
};

export default function DataDisplayPropertiesInputContent({ value }: DataDisplayPropertiesInputContentProps) {
	if (!value || value.length === 0) {
		return null;
	}

	const label = value.length === 1 ? '1 property' : `${value.length} properties`;

	return <InputContentChip label={label} />;
}
